'use strict';

var workerPostFieldSelector = '#siretNumber, #vatNumber, #address';

function getScopeRoot($scope) {
    if ($scope && $scope.length) {
        return $scope;
    }

    return $(document);
}

function setWorkerPostFieldErrorState($input, hasError, message) {
    var $formGroup = $input.closest('.form-group');
    var $error = $formGroup.find('.invalid-feedback').first();

    if ($error.length && message) {
        $error.text(message);
    }

    if ($error.length) {
        $error.toggle(hasError);
    }

    $formGroup.toggleClass('is-invalid', hasError);
    $input.attr('aria-invalid', hasError);
}

function getWorkerPostErrorText($input, key, fallback) {
    return $.trim($input.attr(key) || '') || fallback;
}

function getWorkerPostDefaultRequiredError($input) {
    var message = $.trim($input.closest('.professional-fields').attr('data-required-error') || '');
    return message;
}

function getWorkerPostPattern($input) {
    var patternText = $.trim($input.attr('data-pattern') || '');

    if (patternText) {
        return new RegExp(patternText);
    }

    return null;
}

function validateWorkerPostField($input, validateFormat) {
    var value = $.trim($input.val());
    var formatMessage = getWorkerPostErrorText($input, 'data-error1', getWorkerPostDefaultRequiredError($input));
    var emptyMessage = getWorkerPostErrorText($input, 'data-error2', getWorkerPostDefaultRequiredError($input));
    var pattern = getWorkerPostPattern($input);
    var maxLength = Number($input.attr('maxlength'));

    if (value === '') {
        var isRequired = $input.closest('.form-group').hasClass('required');
        setWorkerPostFieldErrorState($input, isRequired, emptyMessage);
        return !isRequired;
    }

    if (!validateFormat) {
        setWorkerPostFieldErrorState($input, false);
        return true;
    }

    if (pattern && !(pattern.test(value))) {
        setWorkerPostFieldErrorState($input, true, formatMessage);
        return false;
    }

    if (maxLength && value.length > maxLength) {
        setWorkerPostFieldErrorState($input, true, formatMessage);
        return false;
    }

    setWorkerPostFieldErrorState($input, false);
    return true;
}

function bindFieldEvents($scope) {
    var $root = getScopeRoot($scope);
    var $fields = $root.find(workerPostFieldSelector);

    $fields.off('blur.workerPostValidation').on('blur.workerPostValidation', function () {
        validateWorkerPostField($(this), false);
    });

    $fields.off('input.workerPostValidation').on('input.workerPostValidation', function () {
        var $input = $(this);
        if ($.trim($input.val()) !== '') {
            setWorkerPostFieldErrorState($input, false);
        }
    });
}

function validateAll($scope) {
    var isValid = true;
    var $root = getScopeRoot($scope);

    $root.find(workerPostFieldSelector).each(function () {
        isValid = validateWorkerPostField($(this), true) && isValid;
    });

    return isValid;
}

function getFieldValues($scope) {
    var $root = getScopeRoot($scope);

    return {
        siret: $root.find('#siretNumber').val(),
        vat: $root.find('#vatNumber').val(),
        address: $root.find('#address').val()
    };
}

module.exports = {
    bindFieldEvents: bindFieldEvents,
    validateAll: validateAll,
    getFieldValues: getFieldValues
};